import httpHelper from "@/helpers/httpHelper";
// action types
export const REQUEST_HANDLE = "requestHandle";

// mutation types
export const SET_REQUEST_HANDLE = "requestHandle";


export default {
    state: {
        requestResponse:''
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedRequestResponse(state) {
            return state.requestResponse;
        },
    },
    actions: {
        /**
         * Set the comparative list
         * @param state
         * @param payload
         */
          [REQUEST_HANDLE](state, payload) {
            return new Promise((resolve, reject) => { httpHelper
                    .getData(payload)
                    .then((response) => {
                      
                        state.commit(SET_REQUEST_HANDLE, response);
                        resolve(response)
                    })
                    .catch((error) => {
                       reject(error)
                    })
                    .finally(() => {});
                })
        },
    },
    mutations: {
        
        [SET_REQUEST_HANDLE](state, payload) {
            
            state.requestResponse = payload;
            
        },
       
    }
};